import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Page from 'Common/Layout/Page';
import HelpToolTip from '../../../../../Common/HelpToolTip';
import ContractsDatatable from '../../Datatables/ContractsDatatable';
import ViewAlert from '../../Components/ViewAlert/ViewAlert';
import { withClsCompTracking } from '../../../../../Telemetry/telemetry.service';
import Columns from '../../Datatables/ColumnDefinitions';
import {
	saveUpdatedContractFees,
	getContractFees,
	addUpdateToFee,
	clearUpdateFeesErrors,
	clearAllFeesUpdates,
	removeUpdate,
	removeAllEdits,
	getContractFeesCount
} from '../../../../../Redux/Actions/Contract.Fees.Actions';
import CloseButton from '../../../../../Common/CloseButton/CloseButton';
import SaveButton from '../../Components/SaveButton/SaveButton';
import classes from '../contract-views.module.css';
import { qualYearSelect } from 'Redux/Selectors/Contracts.Globals.Selectors';

const FeesManagement = withClsCompTracking('Fees Management Table')(ContractsDatatable);

const ContractFees = ({ handleActiveModal }) => {
	const { selected: qualYear } = useSelector(qualYearSelect);	
	let [scriptyear, setYear] = useState(qualYear.toString());
	const dispatch = useDispatch();
	const [fireShow, setFireShow] = useState(false);
	const types = useSelector(state => state.contract_globals.appointment_types.selected);
	const fees = useSelector(state => state.fees);
	const handleGetContractFees = (contractTypes, year, query, exportData) => dispatch(getContractFees(contractTypes, year, query, exportData));
	const handleFeeUpdate = (field, value, data, fees) => dispatch(addUpdateToFee(field, value, data, fees));
	const handleSaveContractFees = (contractTypes, year, data) => dispatch(saveUpdatedContractFees(contractTypes, year, data));
	const handleFeeErrorClear = () => dispatch(clearUpdateFeesErrors());
	const handleRemoveUpdate = (keyField, id, updates) => dispatch(removeUpdate(keyField, id, updates));
	const handleRemoveAllEdits = () => dispatch(removeAllEdits());
	const handleScriptDateCount = (contractTypes, year) => dispatch(getContractFeesCount(contractTypes, year));
	const handleQualyearUpdate = (year) => setYear(year);	

	document.title = `Contract Management - Contract Fees Initialisation (${types.join(', ')}) ${scriptyear}`;

	const saveContractFees = () => {
		handleSaveContractFees(types, scriptyear, fees.updated);
		setFireShow(true);
	};
	const amendments = fees.updated.length;

	return (
		<>
			<Page title={`Contract Fees Initialisation (${types.join(', ')}) ${scriptyear}`}>
			</Page>
			<HelpToolTip title={`Contract Fees Editing Help`} />
			<ViewAlert show={fees.message !== ''} message={fees.message} errors={fees.errors} clearMessage={handleFeeErrorClear} />
			<FeesManagement
				keyField={'id_type'}
				columns={Columns.ContractFeesColumns}
				contractTypes={types}
				year={scriptyear}
				handleGetData={handleGetContractFees}
				handleAddUpdates={handleFeeUpdate}
				handleClearUpdates={clearAllFeesUpdates}
				removeUpdate={handleRemoveUpdate}
				handleRemoveAllEdits={handleRemoveAllEdits}
				handleGetCount={handleScriptDateCount}
				updateQualYear={handleQualyearUpdate}
				fireShow={fireShow}
				setFireShow={setFireShow}
				amendments={amendments}
				dispatch={dispatch}
				{...fees}
			/>
			<span className={classes['action-buttons']}>
				<CloseButton closeOnClick={() => handleActiveModal('')} hasUpdates={fees.updated && fees.updated.length > 0} />
				<SaveButton saveOnClick={saveContractFees} disabled={ amendments === 0 } />
			</span>
		</>
	);
};

export default ContractFees;
